import { AxiosRequestConfig, AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";

class OrdersService {
	private instance: HttpService;
	private controllerName: string = "orders";

	constructor() {
		this.instance = new HttpService(this.controllerName);
	}

	public get(url: string = "", config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
		return this.instance.get(url, config);
	}

	public post(url: string = "", data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
		return this.instance.post(url, data, config);
	}

	public put(url: string = "", data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
		return this.instance.put(url, data, config);
	}

	public delete(url: string = "", config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
		return this.instance.delete(url, config);
	}
	
    public async setNewOrderStatus(obj: any): Promise<AxiosResponse<any>>  {
        return await this.instance.post('set-new-order-status', obj);
    }
}

const ordersService = new OrdersService();

export default ordersService;